import * as React from 'react';

import GradeLevelSection from '../shared/grade_level_section';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const TeacherGradeLevels = ({ activateSection, active, deactivateSection, passedMaximumGradeLevel, passedMinimumGradeLevel, updateTeacherInfo, }) => {
  const [minimumGradeLevel, setMinimumGradeLevel] = React.useState(passedMinimumGradeLevel)
  const [maximumGradeLevel, setMaximumGradeLevel] = React.useState(passedMaximumGradeLevel)

  React.useEffect(() => {
    if (active) { return }

    reset()
  }, [active])

  React.useEffect(() => {
    if ((minimumGradeLevel !== passedMinimumGradeLevel) || (maximumGradeLevel !== passedMaximumGradeLevel)) {
      activateSection()
    }
  }, [minimumGradeLevel, maximumGradeLevel])

  function reset() {
    setMinimumGradeLevel(passedMinimumGradeLevel)
    setMaximumGradeLevel(passedMaximumGradeLevel)
  }

  function resetAndDeactivateSection() {
    reset()
    deactivateSection()
  }

  function handleSubmit(e) {
    e?.preventDefault()
    const data = {
      minimum_grade_level: minimumGradeLevel.value,
      maximum_grade_level: maximumGradeLevel.value
    };
    updateTeacherInfo(data, 'Settings saved')
  }

  function renderButtonSection() {
    if (!active) { return }

    const submitButtonClassName = "quill-button contained medium green focus-on-light"

    let submitButton = <input aria-label="Save changes" className={`${submitButtonClassName} disabled`} disabled type="submit" value="Save changes" />

    if (minimumGradeLevel && maximumGradeLevel) {
      submitButton = <DemoGuardedButton className={submitButtonClassName} onClick={handleSubmit}>Save changes</DemoGuardedButton>
    }

    return (
      <div className="button-section">
        <button className="quill-button outlined medium grey focus-on-light" id="cancel" onClick={resetAndDeactivateSection} type="button">Cancel</button>
        {submitButton}
      </div>
    )
  }

  return (
    <section aria-labelledby="gradeLevelTitle" className="user-account-section grade-level-section">
      <h1 id="gradeLevelTitle">Grade Level</h1>
      <form acceptCharset="UTF-8" onSubmit={handleSubmit} >
        <div className="fields" onClick={activateSection}>
          <GradeLevelSection
            maximumGradeLevel={maximumGradeLevel}
            minimumGradeLevel={minimumGradeLevel}
            setMaximumGradeLevel={setMaximumGradeLevel}
            setMinimumGradeLevel={setMinimumGradeLevel}
          />
        </div>
      </form>
      {renderButtonSection()}
    </section>
  )
}

export default TeacherGradeLevels
